'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/Link/Link.js';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LinkModule = require('./Link.module.css');

var _LinkModule2 = _interopRequireDefault(_LinkModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired,
  icon: _propTypes2.default.string,
  className: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string
};
var defaultProps = {
  to: null,
  onClick: null,
  icon: null,
  className: null,
  iconClassName: null
};

function Link(_ref) {
  var to = _ref.to,
      children = _ref.children,
      icon = _ref.icon,
      className = _ref.className,
      iconClassName = _ref.iconClassName,
      props = _objectWithoutProperties(_ref, ['to', 'children', 'icon', 'className', 'iconClassName']);

  var linkClassName = (0, _classnames2.default)(_LinkModule2.default.link, className);

  var linkChildren = _react2.default.createElement(_react2.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }, icon && _react2.default.createElement('i', {
    className: (0, _classnames2.default)(_LinkModule2.default.icon, icon, iconClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }), children);

  if (to) {
    return _react2.default.createElement(_reactRouter.Link, _extends({}, props, {
      to: to,
      className: linkClassName,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      },
      __self: this
    }), linkChildren);
  }

  return _react2.default.createElement('a', _extends({}, props, {
    className: linkClassName,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44
    },
    __self: this
  }), linkChildren);
}

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
exports.default = Link;